export enum ContentSource {
    Import = 'Import',
    Internal = 'Internal',
    Facebook = 'Facebook',
    GMB = 'GMB',
    Mobile = 'Mobile',
    Yelp = 'Yelp',
    Zapier = 'Zapier',
    JobNimbus = 'JobNimbus',
    HousecallPro = 'HousecallPro',
    Jobber = 'Jobber',
    Leap = 'Leap',
    AutoScheduled = 'AutoScheduled',
    API = 'API',
    CompanyCam = 'CompanyCam',
    Instagram = 'Instagram',
}

export function isMobileSource(
    source: ContentSource
): source is ContentSource.Mobile {
    return source === ContentSource.Mobile;
}

export function isImportOrInternalSource(
    source: ContentSource
): source is ContentSource.Import | ContentSource.Internal {
    return source === ContentSource.Import || source === ContentSource.Internal;
}

export function isCrmSource(source: ContentSource): boolean {
    return [
        ContentSource.Facebook,
        ContentSource.GMB,
        ContentSource.Yelp,
        ContentSource.Zapier,
        ContentSource.JobNimbus,
        ContentSource.HousecallPro,
        ContentSource.Jobber,
        ContentSource.Leap,
        ContentSource.AutoScheduled,
        ContentSource.API,
    ].includes(source);
}
